export enum WysiwygDisplayVariant {
    left = "left",
    right = "right",
    tooltip = "tooltip"
}
